import { useEffect } from 'react';
import { User } from '../app/store/types/auth.types';
import { isUserAuthenticated } from '../services/locationService';
import { AppDispatch } from '../app/store/store';

export const useAuthSync = (
    user: User | null,
    dispatch: AppDispatch,
    logoutAction: () => any
): void => {
    useEffect(() => {
        // If user exists in Redux state but is not authenticated, log them out
        if (!isUserAuthenticated() && user) {
            dispatch(logoutAction());
        }
    }, [user, dispatch, logoutAction]);
};
